var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer"},[_c('span',[_vm._v("Time : "+_vm._s(_vm._f("prettify")(_vm.time)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }